var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.course
    ? _c(
        "div",
        { staticClass: "intl-course-detail" },
        [
          _c("IntlBreadcrumb", { attrs: { "detail-title": _vm.courseTitle } }),
          _vm._v(" "),
          _c("div", { staticClass: "intl-course-detail__head" }, [
            _c(
              "div",
              {
                staticClass: "intl-course-detail__cover",
                class: "cover--" + _vm.coverCategory,
              },
              [
                _vm.coverImage
                  ? _c("img", {
                      staticClass: "intl-course-detail__cover-image",
                      attrs: { src: _vm.coverImage, alt: "" },
                    })
                  : _c(
                      "span",
                      { staticClass: "intl-course-detail__cover-icon" },
                      [_vm._v(_vm._s(_vm.coverIcon))]
                    ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "intl-course-detail__info" }, [
              _c("span", { staticClass: "intl-course-detail__type" }, [
                _vm._v(_vm._s(_vm.courseType)),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "intl-course-detail__title" }, [
                _vm._v(_vm._s(_vm.courseTitle)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "intl-course-detail__desc" }, [
                _vm._v(_vm._s(_vm.courseDesc)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "intl-course-detail__meta" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.course.hours) +
                      " " +
                      _vm._s(_vm.$t("common.hours"))
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sep" }, [_vm._v("·")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("common.currentLanguage")) +
                      "：" +
                      _vm._s(_vm.langLabel)
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sep" }, [_vm._v("·")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.course.categoryLabel))]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "intl-course-detail__learn",
                  on: { click: _vm.learnCourse },
                },
                [_vm._v(_vm._s(_vm.$t("common.learn")))]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "intl-course-detail__tabs" },
            _vm._l(_vm.tabs, function (tab) {
              return _c(
                "button",
                {
                  key: tab.key,
                  class: { "is-active": _vm.activeTab === tab.key },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = tab.key
                    },
                  },
                },
                [_vm._v(_vm._s(tab.label))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "intl-course-detail__tab-body" }, [
            _vm.activeTab === "intro"
              ? _c("div", { staticClass: "intl-course-detail__intro" }, [
                  _c("p", [_vm._v(_vm._s(_vm.courseDesc))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "intl-course-detail__facts" }, [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.instructor")))]),
                      _c("strong", [_vm._v(_vm._s(_vm.courseInstructor))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.level")))]),
                      _c("strong", [_vm._v(_vm._s(_vm.courseLevel))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.type")))]),
                      _c("strong", [_vm._v(_vm._s(_vm.courseType))]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "outline"
              ? _c(
                  "div",
                  { staticClass: "intl-course-detail__outline" },
                  _vm._l(_vm.outline, function (chapter, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "intl-course-detail__chapter" },
                      [
                        _c(
                          "span",
                          { staticClass: "intl-course-detail__chapter-num" },
                          [_vm._v(_vm._s(String(i + 1).padStart(2, "0")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "intl-course-detail__chapter-title" },
                          [_vm._v(_vm._s(_vm.chapterTitle(chapter)))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "intl-course-detail__chapter-count" },
                          [
                            _vm._v(
                              _vm._s(chapter.lessons) +
                                " " +
                                _vm._s(_vm.$t("common.lessons"))
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.relatedCourses.length
            ? _c("div", { staticClass: "intl-course-detail__related" }, [
                _c("h3", { staticClass: "intl-course-detail__related-title" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("common.relatedCourses")) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "intl-course-detail__related-grid" },
                  _vm._l(_vm.relatedCourses, function (item) {
                    return _c("CourseCard", {
                      key: item.id,
                      attrs: { course: item },
                      on: { click: _vm.goDetail },
                    })
                  }),
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _c("div", { staticClass: "intl-course-detail__loading" }, [
        _vm._v(
          "\n  " +
            _vm._s(
              _vm.loadFailed
                ? _vm.$t("common.contentUnavailable")
                : _vm.$t("common.loading")
            ) +
            "\n"
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }